<template>
  <div class="flex flex-col md:flex-row flex-wrap items-center justify-center mx-4 md:mx-16 mt-4">

    <IdCardStats :titre="t('ordersOnly')"
       :stats="[
         {nom: t('numberOfOrder'), valeur: stats.value.nbCommandes},
         {nom: t('orderCancel'), valeur: stats.value.nbCommandesAnnuler}
       ]" />

    <IdCardStats :titre="t('products')"
       :stats="[
          {nom: t('numberOfProducts'), valeur: stats.value.nbPiecesTotal},
          {nom: t('avgProducts'), valeur: converter.round(stats.value.avgPiecesParCommande)}
       ]" />

    <IdCardStats :titre="t('weights')"
       :stats="[
          {nom: t('totalWeight'), valeur: stats.value.nbPoidsTotal + ' kg'},
          {nom: t('avgWeight'), valeur: converter.round(stats.value.avgPoids) + ' g'}
       ]" />

    <IdCardStats :titre="t('time')"
       :stats="[
          {nom: t('totalTime'), valeur: converter.minToDays(stats.value.nbTempsTotal)},
          {nom: t('avgTime'), valeur: converter.minToHours(stats.value.avgTemps)}
       ]" />

    <IdCardStats :titre="t('price')"
       :stats="[
          {nom: t('priceProduction'), valeur: converter.round(stats.value.prixProductionTotal) + ' €'},
          {nom: t('totalPrice'), valeur: converter.round(stats.value.prixTotal) + ' €'},
          {nom: t('leftToPay'), valeur: converter.round(stats.value.resteAPayer) + ' €'}
       ]" />
  </div>

  <div class="w-full flex flex-col lg:flex-row items-center justify-center mt-8 px-16">
    <PieStats :titre="t('coilUsage')" class="w-10/12 lg:w-3/4"
      :stats="bobinePieStat" v-if="bobinePieStat.length > 0" />

    <HorizontalBarStats class="w-11/12 lg:w-5/6"
      :titre="t('productsByPrinter')" :stats="produitParImprimanteStat" />
  </div>


  <div class="flex flex-col lg:flex-row mx-8 md:mx-16 mt-8 mb-16 items-center">
    <DateVerticalBarsStat :titre="t('orderFor3Years')" :stats="stats.value.dateCommandeParMois"
      class="w-11/12 lg:w-5/6"/>

    <DateVerticalBarsStat :titre="t('productFor3Years')" :stats="stats.value.nbrProduitParMois"
      class="w-11/12 lg:w-5/6"/>
  </div>
</template>

<script setup>

import {t} from "@/utils/Traduction";
import converter from "@/utils/Converter";
import IdCardStats from "@/components/organismes/IdCardStats.vue";
import PieStats from "@/components/molecules/PieStats.vue";
import DateVerticalBarsStat from "@/components/molecules/DateVerticalBarsStat.vue";
import HorizontalBarStats from "@/components/molecules/HorizontalBarStats.vue";
import {computed, defineProps} from 'vue';
import {ArcElement, Chart, Legend, PieController, registerables, Tooltip} from "chart.js";

Chart.register(PieController, ArcElement, Tooltip, Legend, ...registerables);

const props = defineProps({
  stats: {
    type: Object,
    required: true
  }
})

const bobinePieStat = computed(() => {
  return props.stats.value.couleurs.map((couleur) => {
    return {value: couleur.total, color: couleur.code, text: couleur.libelle};
  });
});

const produitParImprimanteStat = computed(() => {
  return props.stats.value.nbProduitParImprimante.map((imprimante) => {
    return {value: imprimante.total, text: imprimante.libelle};
  });
});

</script>

<style scoped>

</style>